import type { ReactNode } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

/** Light/dark switcher — mirrors iPlan4's ThemeToggle (Moon in light, Sun in dark). */
export function ThemeToggle(): ReactNode {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      type="button"
      onClick={toggleTheme}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      aria-label="Toggle theme"
      className="flex size-9 items-center justify-center rounded-md text-foreground hover:bg-muted"
    >
      {theme === 'light' ? <Moon className="size-4" /> : <Sun className="size-4" />}
      <span className="sr-only">Toggle theme</span>
    </button>
  );
}
